import { WarrantyRegistrationSchema } from "@redotech/redo-model/warranty-registration";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getWarrantyRegistration = {
  name: "getWarrantyRegistration" as const,
  input: z.object({
    returnId: zExt.objectId().nullish(),
    registrationId: zExt.objectId().nullish(),
  }),
  output: WarrantyRegistrationSchema,
};
